import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';

@Component({
  selector: 'gn-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnInputComponent),
    multi: true
  }]
})
@GnFormItem('input')
export class GnInputComponent implements ControlValueAccessor {

  private innerValue: string;

  @Input() placeholder = '';

  @Input() set value(v: string) {
    if (this.innerValue !== v) {
      this.innerValue = v;
      this.valueChange(this.innerValue);
    }
  }

  get value(): string {
    return this.innerValue;
  }

  valueChange = (value: string) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
